export default __webpack_public_path__ + "static/media/skyPondPhoneFormatter.133ee6dc.jpg";